import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import { Grid2, IconButton, List, ListItem, TextField, Typography, useTheme } from "@mui/material";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { groupIngredientsByGroup, handleAddIngredient, handleFieldChange, handleRemoveIngredient } from "../../utils/ingerdientUtils";

const IngredientsWide = ({ ingredients, onIngredientsChange }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const [newIngredient, setNewIngredient] = useState({
    name: "",
    quantity: "",
    unit: "",
    notes: "",
    group: "",
  });

  const [errors, setErrors] = useState({});

  const groupedIngredients = groupIngredientsByGroup(ingredients);

  return (
    <>
      <Grid2 container spacing={2} alignItems="center" sx={{ pt: theme.spacing(1.5) }}>
        <Grid2 xs={3.5}>
          <TextField
            label={t("name")}
            name="name"
            value={newIngredient.name}
            onChange={(e) => handleFieldChange(e, true, null, newIngredient, setNewIngredient, ingredients, onIngredientsChange, setErrors, t)}
            fullWidth
          />
        </Grid2>
        <Grid2 xs={2.5}>
          <TextField
            label={t("quantity")}
            name="quantity"
            value={newIngredient.quantity}
            onChange={(e) => handleFieldChange(e, true, "new", newIngredient, setNewIngredient, ingredients, onIngredientsChange, setErrors, t)}
            fullWidth
            error={!!errors.new?.quantity}
            helperText={errors.new?.quantity}
          />
        </Grid2>
        <Grid2 xs={2.5}>
          <TextField
            label={t("unit")}
            name="unit"
            value={newIngredient.unit}
            onChange={(e) => handleFieldChange(e, true, null, newIngredient, setNewIngredient, ingredients, onIngredientsChange, setErrors, t)}
            fullWidth
            error={!!errors.unit}
            helperText={errors.unit}
          />
        </Grid2>
        <Grid2 xs={3}>
          <TextField
            label={t("notes")}
            name="notes"
            value={newIngredient.notes}
            onChange={(e) => handleFieldChange(e, true, null, newIngredient, setNewIngredient, ingredients, onIngredientsChange, setErrors, t)}
            fullWidth
          />
        </Grid2>
        <Grid2 xs={0.5} sx={{ display: "flex", justifyContent: "center" }}>
          <IconButton
            sx={{ bgcolor: theme.palette.primary.main, color: theme.palette.primary.contrastText }}
            onClick={() => handleAddIngredient(newIngredient, ingredients, onIngredientsChange, setNewIngredient, setErrors, t)}
          >
            <AddIcon />
          </IconButton>
        </Grid2>
      </Grid2>

      <List sx={{ p: 0, m: 0, pt: theme.spacing(2) }}>
        {Object.entries(groupedIngredients).map(([group, items], groupIndex) => (
          <React.Fragment key={group}>
            {group !== "__no_group__" && (
              <Typography
                id={`ingredient-group-${groupIndex}`}
                component="h3"
                variant="h6"
                sx={{
                  fontWeight: 600,
                  mb: 1.5,
                  mt: groupIndex > 0 ? 2 : 0,
                  borderBottom: `solid ${theme.palette.divider}`,
                  color: theme.palette.text.primary,
                }}
              >
                {group}
              </Typography>
            )}
            {items.map((ingredient, index) => (
              <ListItem key={index} sx={{ p: 0, m: 0, pb: theme.spacing(2) }}>
                <Grid2 container spacing={2} alignItems="center">
                  <Grid2 xs={3.5}>
                    <TextField
                      label={t("name")}
                      name="name"
                      value={ingredient.name}
                      onChange={(e) => handleFieldChange(e, false, index, newIngredient, setNewIngredient, ingredients, onIngredientsChange, setErrors, t)}
                      fullWidth
                    />
                  </Grid2>
                  <Grid2 xs={2.5}>
                    <TextField
                      label={t("quantity")}
                      name="quantity"
                      value={ingredient.quantity}
                      onChange={(e) => handleFieldChange(e, false, index, newIngredient, setNewIngredient, ingredients, onIngredientsChange, setErrors, t)}
                      fullWidth
                      error={!!errors[index]?.quantity}
                      helperText={errors[index]?.quantity}
                    />
                  </Grid2>
                  <Grid2 xs={2.5}>
                    <TextField
                      label={t("unit")}
                      name="unit"
                      value={ingredient.unit}
                      onChange={(e) => handleFieldChange(e, false, index, newIngredient, setNewIngredient, ingredients, onIngredientsChange, setErrors, t)}
                      fullWidth
                      error={!!errors.unit}
                      helperText={errors.unit}
                    />
                  </Grid2>
                  <Grid2 xs={3}>
                    <TextField
                      label={t("notes")}
                      name="notes"
                      value={ingredient.notes}
                      onChange={(e) => handleFieldChange(e, false, index, newIngredient, setNewIngredient, ingredients, onIngredientsChange, setErrors, t)}
                      fullWidth
                    />
                  </Grid2>
                  <Grid2 xs={0.5} sx={{ display: "flex", justifyContent: "center" }}>
                    <IconButton onClick={() => handleRemoveIngredient(index, ingredients, onIngredientsChange)} edge="end">
                      <DeleteIcon sx={{ color: theme.palette.error.main }} />
                    </IconButton>
                  </Grid2>
                </Grid2>
              </ListItem>
            ))}
          </React.Fragment>
        ))}
      </List>
    </>
  );
};

export default IngredientsWide;
